import { Component, OnInit } from '@angular/core';
import { DialogService } from '@service/dialog.service';
import { FireAnalyticsService } from '@service/fire-analytics.service';

@Component({
  selector: 'app-demat-account',
  templateUrl: './demat-account.component.html',
  styles: [
  ]
})
export class DematAccountComponent implements OnInit {

  isApp: boolean;
  cordova: any;

  constructor(
    private dialogService: DialogService,
    private analytics: FireAnalyticsService
  ) { }

  ngOnInit(): void {
  }
  goTo(page) {
    if (page === 'alice_blue_login') {
      this.analytics.logEvents('Open Demat Account', { broker: 'alice_blue' });
      this.openInBrowser('https://alicebluepartner.com/open-myaccount/?P=SPN77');
    } else if (page === 'master_trust_login') {
      this.analytics.logEvents('Open Demat Account', { broker: 'master_trust' });
      this.openInBrowser('https://www.mastertrust.co.in/products-pricing/UTM001');
    } else if (page === 'five_paisa_login') {
      this.analytics.logEvents('Open Demat Account', { broker: 'five_paisa' });
      this.openInBrowser('https://www.5paisa.com/landing/open-demat-online#utm_source=pickright&utm_medium=pickright&utm_campaign=pickright_acq_alliance&utm_id=pickright&utm_term=pickright&utm_content=value');
    } else if (page === 'klever_trade') {
      this.analytics.logEvents('Open Demat Account', { broker: 'klever_trade' });
      this.openInBrowser('https://ekyc.arhamwealth.com:8000/index.aspx');
    } else if (page === 'zerodha') {
      this.analytics.logEvents('Open Demat Account', { broker: 'zerodha' });
      this.openInBrowser('https://zerodha.com/open-account?c=ZMPHTB');
    } else if (page === 'aditya_birla') {
      this.analytics.logEvents('Open Demat Account', { broker: 'aditya_birla' });
      this.openInBrowser('https://stocksandsecurities.adityabirlacapital.com/eKYCcampaign/ekyccampaign_registernew.aspx');
    } else if (page === 'nuvama') {
      this.analytics.logEvents('Open Demat Account', { broker: 'nuvama' });
      this.openInBrowser('https://onboarding.nuvamawealth.com/?utm_source=AFFILIATES&utm_campaign=PICKRIGHT&utm_content=AOFWAIVER');
    } else if (page === 'bajaj') {
      this.analytics.logEvents('Open Demat Account', { broker: 'bajaj' });
      this.openInBrowser('https://free-demat.bajajfinservsecurities.in/?utm_source=Freedom_Plus&referal_code=P6883');
    }
  }


  closeDialog() {
    this.dialogService.closeAll()
  }

  openInBrowser(link) {
    if (this.isApp) {
      this.cordova.InAppBrowser.open(link, '_system', 'location=yes');
    } else {
      const e = document.createElement('a');
      e.setAttribute('href', link);
      e.setAttribute('target', '_blank');
      e.click();
    }
  }

}
